import React from "react";

// ── ScoreRing ─────────────────────────────────────────────────────────────────
export function ScoreRing({ score, size = 52, strokeWidth = 4 }) {
  const r   = (size - strokeWidth * 2) / 2;
  const c   = r * 2 * Math.PI;
  const off = c - (score / 100) * c;

  const color =
    score >= 70 ? "var(--success)"  :
    score >= 50 ? "var(--warning)"  :
                  "var(--error)";

  const fontSize = size < 50 ? 11 : size < 70 ? 13 : 16;

  return (
    <div className="score-ring" style={{ width: size, height: size }}>
      <svg width={size} height={size}>
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="var(--gray-200)" strokeWidth={strokeWidth} />
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={color} strokeWidth={strokeWidth}
          strokeDasharray={c} strokeDashoffset={off} strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.5s ease" }}
        />
      </svg>
      <span className="score-ring-value" style={{ fontSize, color }}>{score}%</span>
    </div>
  );
}

// ── StatusBadge ───────────────────────────────────────────────────────────────
const STATUS = {
  QA_PASSED:          { label: "Passed",     cls: "passed" },
  QA_FAILED:          { label: "Failed",     cls: "failed" },
  PROCESSING:         { label: "Processing", cls: "processing" },
  RECEIVED:           { label: "Received",   cls: "pending" },
  EXTRACTION_FAILED:  { label: "Ext. Error", cls: "failed" },
  INDEXED:            { label: "Indexed",    cls: "passed" },
  CLOSED:             { label: "Closed",     cls: "passed" },
  REVIEWED:           { label: "Reviewed",   cls: "passed" },
};

export function StatusBadge({ status }) {
  const s = STATUS[status] || { label: status, cls: "pending" };
  return (
    <span className={`badge ${s.cls}`}>
      <span className="badge-dot" /> {s.label}
    </span>
  );
}